module.exports = __webpack_public_path__ + "static/img/14.07f9ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/14.png
// module id = OPoD
// module chunks = 0